import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Calendar } from '@vds/calendars';
import { Notification } from "@vds/notifications"
import { Body, Title } from '@vds/typography';
import { Checkbox } from "@vds/checkboxes";
import Footer from '../../shared/components/Footer';
import { useNavigate, useLocation } from 'react-router-dom';
import { useGetDevicesAndPlansByNameQuery } from '../../features/devicesAndPlans/devicesAndPlansFetch';
import { getDestList } from '../../shared/utils/globalUtils';
import FullPageLoader from '../../shared/components/Loader';
import { isDesktop, isTab, isMdot, isNative } from '../../shared/utils/globalConfig';
import { useSelector, useDispatch } from 'react-redux'
import { formatDate, getErrorMessage } from '../../shared/utils/globalUtils';
import { updateCart } from '../../features/devicesAndPlans/updatePlans';
import { updateSelectedPlanData, saveFailedPlanData } from '../../features/selectedData/selectedDataReducer';
import { saveConfirmedPlanData, savePlanEffectiveDate } from '../../features/selectedData/persistantDataReducer';
import { dispatchNotifyEvent, dispatchPageView } from '../../shared/utils/tagging';
import {getDevicesPayload } from '../../shared/utils/globalUtils';
import { useItpPageTools } from '../../shared/hooks/useItpPageTools';
import { buildEffectiveDateTools } from '../../shared/pageTools/itpPageTools';

const EffectiveDateMain = styled.div`
`
const Space = styled.div`
padding-top: 24px;
`

const StyledHeader = styled.div`
width:${isDesktop ? '45%' : isTab ? "60%" : ''};
`
const StyledText = styled.div`
width:${isDesktop || isTab ? '60%' : ''};
`
const StyledMargin = styled.div`
margin-left:${isMdot || isNative ? '2%' : ''};
`

export default function EffectiveDate() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { selectedDestinations, selectedDates, confirmedPlanData, planEffectiveDate } = useSelector(state => state?.persistantReducer);
    const { selectedDeviceDetails, failedUpdateCartData, planUpdatedData } = useSelector(state => state?.selectedReducer);

    const [dateSelected, setDateSelected] = useState();
    const [showLoader, setShowLoader] = useState(false);
    const [defaultDate, setDefaultDate] = useState();

    const { data, error, isLoading, isSuccess } = useGetDevicesAndPlansByNameQuery(getDevicesPayload(selectedDates, selectedDestinations));
    const [effectiveDateData, setEffectiveDateData] = useState();
    const [recurringSelected, setRecurringSelected] = useState(false);
    const [dateAdvisory, setDateAdvisory] = useState(false);

    useEffect(() => {
        setEffectiveDateData(data?.body?.data?.effectiveDatesInfo)
        setDefaultDate(planEffectiveDate ? planEffectiveDate : data?.body?.data?.effectiveDatesInfo?.defaultDate)
    }, [data]);
    //Tagging
    useEffect(() => {
        if (effectiveDateData?.notificationtext) {
            dispatchNotifyEvent(effectiveDateData?.notificationtext)
        }
    }, [effectiveDateData])

    useEffect(() => {
        dispatchPageView('ITP_EffectiveDate', '', '#effective_date');
    }, [])

    useEffect(() => {
        if (Object.keys(selectedDeviceDetails).length === 0) {
            navigate(-1, { replace: true })
        }
    }, [selectedDeviceDetails])

    const getRecurrPlanTypeDetails = () => {
        const recurPlanData = data?.body?.data?.planDetailsLand?.planInfo?.filter(plan => plan?.planTypeName === 'MONTHLY_RECURRING');
        return recurPlanData;
    }
    const getEffectivePlanFeatures = (features) => {
        let currentPlan = features;
        if (recurringSelected) {
            const recurPlan = getRecurrPlanTypeDetails();
            let [plan] = currentPlan;
            plan.newPlanId = recurPlan[0]?.planId || '';
            plan.newPlanCategory = recurPlan[0]?.category || '';
        }
        return currentPlan;
    }

    const getUpdatedPlanEffective = (plan) => {
        let updatedPlan = plan;
        if (recurringSelected) {
            const recurPlan = getRecurrPlanTypeDetails();
            let [newupdated] = updatedPlan;
            newupdated.planName = recurPlan[0]?.updatedPlanName || '';
            newupdated.planCost = recurPlan[0]?.updatedPlanCost || '';
        }
        return updatedPlan;
    }

    let updateCartFromEffective = (planDetails) => {
        setShowLoader(true);
        let payloadObj = {
            'mtn': planDetails?.mtn,
            'features': planDetails?.featuresCart,
            'effectiveDate': planDetails?.effectiveDate
        }
        let response = updateCart(payloadObj);
        response.then(res => {
            if (res?.data?.responseInfo?.responseCode == 0) {
                let updatedPlanObj = [...confirmedPlanData, planDetails]

                if (planDetails?.updatedPlanDetails.find((plan) => plan.currentPlan === false)) {
                    const updatedEffectiveDateObj = JSON.parse(JSON.stringify(updatedPlanObj)).map((plan) => {
                        if (plan?.effectiveDate) {
                            plan.effectiveDate = planDetails?.effectiveDate
                        }
                        return plan;
                    })
                    dispatch(savePlanEffectiveDate(planDetails?.effectiveDate));
                    dispatch(saveConfirmedPlanData(updatedEffectiveDateObj));
                }
            } else {
                const { title, message } = getErrorMessage(res);
                let errorPlanData = JSON.parse(JSON.stringify(planDetails));
                errorPlanData['errorTitle'] = title?.itemValue;
                errorPlanData['errorMessage'] = message?.itemValue;
                let plan = [...failedUpdateCartData, errorPlanData]
                dispatch(saveFailedPlanData(plan));
            }
            setShowLoader(false);
            navigate(-1, { replace: true })

        }).catch(err => {
            const { title, message } = getErrorMessage(err?.response)
            let errorPlanData = JSON.parse(JSON.stringify(planDetails));
            errorPlanData['errorTitle'] = title?.itemValue;
            errorPlanData['errorMessage'] = message?.itemValue;
            let planobj = [...failedUpdateCartData, errorPlanData]
            dispatch(saveFailedPlanData(planobj));
            setShowLoader(false);
            navigate(-1, { replace: true })
        })
    }

    const submitEffectiveDate = () => {
        let planObj = JSON.parse(JSON.stringify(planUpdatedData));
        planObj.featuresCart = getEffectivePlanFeatures(planObj.featuresCart);
        planObj.featuresConfirm = getEffectivePlanFeatures(planObj.featuresCart);
        planObj['effectiveDate'] = dateSelected ? dateSelected : defaultDate;
        planObj['recurringPlan'] = recurringSelected;
        planObj.updatedPlanDetails = getUpdatedPlanEffective(planObj.updatedPlanDetails);
        dispatch(updateSelectedPlanData(planObj));
        if (selectedDeviceDetails?.skipCruiseAndFlightPlans) {
            navigate("/itpskipplan", { replace: true })
        } else if (selectedDeviceDetails?.cruisePlan || selectedDeviceDetails?.inflightPlan || selectedDeviceDetails?.payAsYouGoSea) {
            navigate("/itpcruiseplanselection", { replace: true })
        } else {
            updateCartFromEffective(planObj);
        }
    }

    const handleDateSelected = (date) => {
        const selectDate = formatDate(date);
        setDateSelected(selectDate);
        if (selectDate !== defaultDate) {
            setDateAdvisory(true)
        } else {
            setDateAdvisory(false)
        }

    }

    const monthlyTypeSelected = (e) => {
        setRecurringSelected(e.target.checked);
    }

    const effectiveDateTools = buildEffectiveDateTools({
        minDate: effectiveDateData?.minDate,
        maxDate: effectiveDateData?.maxDate,
        onDateSelected: handleDateSelected,
        onRecurringChange: setRecurringSelected,
        onContinue: submitEffectiveDate,
    });

    useItpPageTools('intl-nsa-effective-date', effectiveDateTools);

    return (

        <EffectiveDateMain id="effective_date">
            {(!isLoading && effectiveDateData) ?
                <>
                    <Notification
                        type="warning"
                        title={effectiveDateData?.notificationtext}
                        fullBleed={false}
                        inline={false}
                        disableFocus={true}
                    />
                    <Space pt={24}></Space>
                    {dateAdvisory &&
                        <><Notification
                            type="info"
                            title={effectiveDateData?.advisoryEffectiveDate?.replace('##date##', dateSelected)}
                            fullBleed={false}
                            inline={false}
                            disableFocus={true}
                        /><Space pt={24}></Space></>}
                    <StyledHeader>
                        <Title size="XLarge">{effectiveDateData?.heading}</Title>
                        <Space pt={24}></Space>
                        <Body size="XLarge">{effectiveDateData?.subText}</Body>
                        <Space pt={24}></Space>
                    </StyledHeader>
                    <StyledMargin>
                        <Calendar
                            selectedDate={defaultDate}
                            minDate={new Date(effectiveDateData?.minDate)}
                            maxDate={new Date(effectiveDateData?.maxDate)}
                            onChange={(_date) => handleDateSelected(_date)}
                        />
                    </StyledMargin>
                    <Space pt={24}></Space>
                    <Checkbox
                        name="checkbox"
                        role="checkbox"
                        width="auto"
                        label={effectiveDateData?.checkBoxText}
                        disabled={false}
                        error={false}
                        errorText="Please agree to the terms and conditions."
                        onChange={(e) => monthlyTypeSelected(e)}
                    >
                        <StyledText>{effectiveDateData?.checkBoxSubText}</StyledText>
                    </Checkbox>
                    <Space pt={24}></Space>

                    <Footer ariaLabel={`auto renew:${recurringSelected}|next`} ctaLabel={effectiveDateData?.ctaLabel} disabled={false} handleButtonChange={() => submitEffectiveDate()} dataTrack={`${dateSelected}|next`} >
                    </Footer>
                </>
                :
                <FullPageLoader></FullPageLoader>}
            {showLoader && <FullPageLoader />}
        </EffectiveDateMain>
    );
} 